import { mapActions, mapGetters } from 'vuex';
import { translationKeyByCode } from '@/locales/locales';

export default {
  name: 'HeaderLang',
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(['languages', 'currentLanguage']),
    ...mapGetters({
      user: 'profile/user'
    })
  },
  methods: {
    ...mapActions({
      setUserLocale: 'profile/SET_USER_LOCALE'
    }),
    changeLanguage(code) {
      // Authenticated users persist the choice so the bootstrap freeze
      // (App.vue) won't revert it on the next load.
      if (this.user) {
        const translationKey = translationKeyByCode(code);
        const persist = translationKey ? this.setUserLocale(translationKey).catch(() => {}) : Promise.resolve();

        persist.then(() => {
          this.$setLanguage(code).then(() => {
            window.location.reload();
          });
        });

        return;
      }

      this.$setLanguage(code).then(() => {
        window.location.reload();
      });
    }
  }
};
